import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';

const CHANGE_EVENT = 'change';
const FORM_CHANGE_EVENT = 'form_change';

let _groups = [];
let _stats = {};

let UserGroupStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    addListener: function(callback) {
        this.addChangeListener(callback);
        return { remove: () => this.removeChangeListener(callback) };
    },
    getAll: function() {
         return _groups.filter(function(e) { return e !== undefined; });
    },
    getById: function(id) {
        return _groups.find(function(e) { return e !== undefined && e.id == id; });
    },
    add: function(entity) {
        if (!!entity && !!entity.id) {
            let index = _groups.findIndex(function(e) { return e !== undefined && e.id == entity.id; });
            if (0 <= index) {
                _groups[index] = entity;
            } else {
                _groups.push(entity);
            }
        }
    },
    delete: function(data) {
        if (!!data.id) {
            var index = _groups.findIndex(function(e) { return e !== undefined && e.id == data.id; });
            if (0 <= index) {
                if (!!data.deleted) {
                    delete _groups[index];
                }
            }
        }
    },

});

UserGroupStore.dispatchToken = CentricDispatcher.register(function(action) {

    switch(action.type) {

        case ActionTypes.USER_GROUP_LIST:
            action.data.forEach(UserGroupStore.add);
            UserGroupStore.emitChange();
            break;

        case ActionTypes.USER_GROUP_LIST_ERROR:
            UserGroupStore.emitChange();
            break;

        case ActionTypes.USER_GROUP_INFO:
            UserGroupStore.add(action.data);
            UserGroupStore.emitChange();
            break;

        case ActionTypes.USER_GROUP_INFO_ERROR:
            UserGroupStore.emitChange();
            break;

        case ActionTypes.USER_GROUP_UPDATE:
            UserGroupStore.add(action.data);
            UserGroupStore.emitChange();
            break;

        case ActionTypes.USER_GROUP_DELETE:
            UserGroupStore.delete(action.data);
            UserGroupStore.emitChange();
            break;

        default:
            break;
    
    }

});

export default UserGroupStore;
